module.exports = __webpack_public_path__ + "static/media/like.d8980221.svg";